import { memo } from 'react';
import SharedBreadcrumbs, { type BreadcrumbsProps } from '@cx-web/components/page-template/Breadcrumbs';

import { type Repub } from '@cx-modules/constants';

// RR7 atlas glue for the shared BREADCRUMBS. The component lives once in
// `@cx-web/components/page-template/Breadcrumbs` (shared with atlas-astro); this glue only adapts RR7's
// prop shape — the page template feeds `requestUrl` (a full URL on the server that round-trips through
// loader JSON and may arrive path-only on the client), which we reduce to a pathname for the shared
// component's `path`. The placeholder base keeps `new URL()` from throwing on relative client input.
interface RR7BreadcrumbsProps {
  dataSchema?: BreadcrumbsProps['dataSchema'];
  repub: Repub;
  requestUrl: string;
}

function Breadcrumbs({ dataSchema, repub, requestUrl }: RR7BreadcrumbsProps) {
  const path = new URL(requestUrl, 'https://placeholder.invalid').pathname;

  return <SharedBreadcrumbs dataSchema={dataSchema} path={path} repub={repub} />;
}

export default memo(Breadcrumbs);
